import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HistoryDashboardComponent } from './components/history-dashboard/history-dashboard.component';
import { HistoryGraphComponent } from './components/history-graph/history-graph.component';
import { DashboardModule } from '../dashboard/dashboard.module';
import { AuthorizationModule } from '../../authorization/authorization.module';

@NgModule({
  imports: [
    CommonModule,
    DashboardModule,
    AuthorizationModule
  ],
  declarations: [HistoryDashboardComponent, HistoryGraphComponent],
  exports: [HistoryDashboardComponent]
})
export class StudentHistoryModule { }
